import React, {
  useState,
  useMemo,
  useCallback,
  PropsWithChildren,
} from "react";
import { SubscriptionPlanModuleId } from "@jugl-web/rest-api";
import { ModuleInfoContext } from "./ModuleInfoContext";
import { WorkspaceFeatureDialog } from "../pages/WorkspaceFeaturesPage/components/WorkspaceFeatureDialog/WorkspaceFeatureDialog";

const ModuleInfoProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [openedModuleId, setOpenedModuleId] =
    useState<SubscriptionPlanModuleId | null>(null);
  const [isShowcaseFlow, setIsShowcaseFlow] = useState<boolean>(false);
  const [shouldShowConfetti, setShouldShowConfetti] = useState(false);

  const showModuleInfo = useCallback(
    ({
      moduleId,
      isShowcase,
      showConfetti,
    }: {
      moduleId: SubscriptionPlanModuleId;
      isShowcase?: boolean;
      showConfetti?: boolean;
    }) => {
      setOpenedModuleId(moduleId);
      setIsShowcaseFlow(!!isShowcase);
      setShouldShowConfetti(!!showConfetti);
    },
    []
  );

  const handleCloseModuleInfo = useCallback(() => {
    setOpenedModuleId(null);
    setIsShowcaseFlow(false);
    setShouldShowConfetti(false);
  }, []);

  const value = useMemo(
    () => ({
      showModuleInfo,
    }),
    [showModuleInfo]
  );

  return (
    <ModuleInfoContext.Provider value={value}>
      <WorkspaceFeatureDialog
        isOpen={!!openedModuleId}
        feature={openedModuleId}
        onClose={handleCloseModuleInfo}
        isShowcaseFlow={isShowcaseFlow}
        shouldShowConfetti={shouldShowConfetti}
      />
      {children}
    </ModuleInfoContext.Provider>
  );
};

export { ModuleInfoProvider };
